import { COOKIE_VISITOR_ID } from '@config/constants'

import { getCorrelationId, refreshCorrelationIdCookie } from './helpers'

export const refreshVisitorIdCookie = (cookies, res) => {
  const visitorId = getCorrelationId(cookies, COOKIE_VISITOR_ID)

  return refreshCorrelationIdCookie(COOKIE_VISITOR_ID, visitorId, res)
}
